import { routeTemplate } from '../store/routesConfig';
import { generatePath } from 'react-router';
import { zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz';
import { format } from 'date-fns';
import { pushHashParams } from './hashParams';

const tz = 'America/New_York';

const formatTeamString = (teamName) => {
    if (!teamName) {
        return '';
    }
    return teamName?.toLowerCase().replace(/ /g, '-').replace(/[^a-zA-Z0-9-]/g, '');
};

const gameStatsToView = {
    X: 'preview',
    C: 'preview',
    D: 'preview',
    S: 'preview',
    P: 'preview',
    RK: 'preview',
    M: 'live',
    N: 'live',
    I: 'live',
    PW: 'live',
    T: 'live',
    U: 'live',
    O: 'final',
    F: 'final',
    Q: 'final',
    R: 'final',
    W: 'final'
};

const generateParamsFromGame = (gameData) => {
    const genParams = {};
    const {
        teams,
        game: {
            pk
        } = {},
        datetime: {
            dateTime
        } = {}
    } = gameData;

    const dataHomeTeam = formatTeamString(teams?.home?.teamName);
    const dataAwayTeam = formatTeamString(teams?.away?.teamName);
    const date = gameData?.status?.startTimeTBD ? zonedTimeToUtc(dateTime, tz) : utcToZonedTime(dateTime, tz);
    const dateList = format(date, 'MM dd yyyy')?.split(' ');
    genParams.gamepk = pk;
    genParams.teams = dataAwayTeam + '-vs-' + dataHomeTeam;
    genParams.year = dateList[2];
    genParams.day = dateList[1];
    genParams.month = dateList[0];
    return genParams;
};

const customUrlBuilder = (state) => {
    const {
        gumbo: { gameData },
        views: {
            timecode,
            game_tab,
            game_view,
            detail
        },
        router: {
            location = {}
        } = {}
    } = state;

    if (!gameData) {
        return '';
    }

    const gameParams = generateParamsFromGame(gameData, game_view);
    const pathNameObj = { ...gameParams };
    // only append tab when view exists in the url;

    if (game_view) {
        pathNameObj.view = game_view;
        if (game_tab) {
            pathNameObj.tab = game_tab;

            if (detail) {
                pathNameObj.detail = detail;
            }
        }
    } else {
        // if no game_view we will assign the view by current game state;
        const currentGameState = gameData?.status.statusCode;
        const canonicalView = gameStatsToView[currentGameState] || gameStatsToView[currentGameState.charAt(0)];
        pathNameObj.view = canonicalView;
    }

    const routePath = generatePath(routeTemplate, pathNameObj);
    const query = new URLSearchParams(location.search);

    // We may want to alter the timecode at some point
    // and force a sync from state... either way here's how
    // we can sync state and query in general
    if (timecode) {
        // If we have a timecode, but it didn't come
        // from the query - don't push it (likely mlb tv scenario)
        if (query.has('tfs') && query.get('tfs') !== timecode) {
            query.set('tfs', timecode);
        }
    } else {
        // oh, its not in state at all?  Get rid of it.
        query.delete('tfs');
    }

    return [{ pathname: routePath, search: query.toString() }];
};

const customHashUrlBuilder = (state) => {
    const {
        config: { hashState: { separator: hashParamSeparator } = {} }
    } = state;

    const pushPath = customUrlBuilder(state);

    try {
        pushHashParams(state, hashParamSeparator);
    } catch (e) {
        console.error('GD: Hash param update failed', e);
    }

    return pushPath;
};

export default customUrlBuilder;
export { customHashUrlBuilder };
